import OrderCargoOrderActiveListRequest, {
  OrderCargoOrderActiveListRequestQueryParams,
} from "./order-cargo-order-active-list.request";

const createQueryParams = (
  data: OrderCargoOrderActiveListRequest,
): OrderCargoOrderActiveListRequestQueryParams => {
  return {
    creationEnd: data.creationEnd,
    creationStart: data.creationStart,
  };
};

const orderCargoOrderActiveListRequestFactory = {
  createQueryParams,
};

export default orderCargoOrderActiveListRequestFactory;
